import logo from './images/logo.png';
import parallaxBkg from './images/parallax-bkg.jpg'
import decennal from './images/decennale.png';
import signature from './images/signature.png';
import { createRef, useEffect, useState } from 'react';
import { smoothScroll } from './utils';
import { AiOutlineHome, AiOutlineMail } from 'react-icons/ai';
import { BsChevronDoubleRight, BsFacebook, BsTelephone } from 'react-icons/bs';
import { Parallax, Background } from 'react-parallax';
import { Slide, Zoom } from "react-awesome-reveal";
import Gallery from './Gallery';
import ChangingTopic from './ChangingTopic';
import ContactForm from './ContactFrom';
import { Footer } from './Footer';
import { Link, useParams } from 'react-router-dom';
import { defaultGeoData, geoPages } from './geoData';


const MenuOption = ({title, icon, _ref}) => <div className="flex exo" onClick={() => _ref && smoothScroll(_ref)}>
  <b className={`clickable${icon ? '' : ' menu-option'}`}>
    { icon || title }
  </b>
</div>

function handleOpenFb() {
  window.open('https://www.facebook.com/profile.php?id=61590766014369', '_blank');
}


/****  S E O  ****/
// Inject dynamic <title> and <meta description> pour react-snap
function useSeoMeta({ title, description, slug }) {
  useEffect(() => {
    document.title = title;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'description');
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', description);

    // canonical
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', `https://www.darduin-carrelage.fr/${slug}`);
  }, [title, description, slug]);
}
// JSON-LD LocalBusiness + Service
function GeoJsonLd({ geoData }) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: `Pose de carrelage à ${geoData.ville}`,
    description: `Artisan carreleur réalisant tous types de revêtements sols et murs, intérieur et extérieur. Carrelage, faïence, douche italienne, terrasse. Intervention à ${geoData.ville}, ${geoData.quartiers} et dans tout le département de ${geoData.dptArticle} ${geoData.departement}`,
    url: `https://www.darduin-carrelage.fr/${geoData.slug}`,
    areaServed: {
      '@type': 'City',
      name: geoData.ville,
      containedInPlace: {
        '@type': 'AdministrativeArea',
        name: geoData.departement,
      },
    },
    provider: {
      '@type': 'LocalBusiness',
      name: 'Darduin Carrelage',
      url: 'https://www.darduin-carrelage.fr',
      telephone: '+33781155793',
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Marchélepot',
        postalCode: '80200',
        addressCountry: 'FR',
      },
    },
    offers: {
      '@type': 'Offer',
      availability: 'https://schema.org/InStock',
      areaServed: { '@type': 'City', name: geoData.ville },
    },
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}
/***  /SEO  ***/

const menuOptions = {
    accueil: {
      title: 'Accueil',
      ref: createRef()
    },
    apropos: {
      title: 'À propos',
      ref: createRef()
    },
    projets: {
      title: 'Réalisations',
      ref: createRef()
    },
    facebook: { 
      icon: <BsFacebook className='hoverscale' size={30} onClick={handleOpenFb}/>
    },
};

const contactRef = createRef();


function MainPage({isMobile}) {

  const { slug } = useParams();
  const geoData = geoPages.find(p => p.slug === slug);
  useSeoMeta(geoData || defaultGeoData);
  const [scrolled, setScrolled] = useState(false);
  const headerRef = createRef(null);
  const [headerHeight, setHeaderHeight] = useState(0);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > window.innerHeight * .05);
    window.addEventListener("scroll", onScroll);

    if (headerRef.current) {
      setHeaderHeight(headerRef.current.offsetHeight);
    }

    return () => window.removeEventListener("scroll", onScroll);
  }, []);


  return <div className='App' ref={menuOptions.accueil.ref}>
      {/* HEADER */}
      {
        geoData
        ? <GeoJsonLd geoData={geoData} />
        : null
      }
      {
        isMobile 
        ? <div className="flex row justifystart secondarybkg white" style={{height: '5vh', maxHeight: '5vh'}}>
            <div className='flex row'>
              <BsTelephone />
              &nbsp;
              07 81 15 57 93
            </div>
            <div className='flex row'>
              <AiOutlineMail />
              &nbsp;
              pierre.darduin@gmail.com
            </div>
        </div> 
        : <div className="flex row justifystart secondarybkg white" style={{height: '5vh', maxHeight: '5vh'}}>
            <div className='flex row'>
              <AiOutlineHome />
              &nbsp;
              80200 Marchélepot, France
            </div>
            <div className='flex row'>
              <BsTelephone />
              &nbsp;
              07 81 15 57 93
            </div>
            <div className='flex row'>
              <AiOutlineMail />
              &nbsp;
              pierre.darduin@gmail.com
            </div>

            <div className='flex row clickable hovergrey primarybkg allheight bold' onClick={() => smoothScroll(contactRef)} >
              Me Contacter 
              &nbsp;
              <BsChevronDoubleRight />
            </div>
          </div>
      }

      <div ref={headerRef} className={`header flex row ${scrolled ? 'fixed-scrolled-header' : ''}`}>
        <div className='flexdot2'>
          <img src={logo} className="app-logo img-shadow" alt="logo" />  
        </div>
        <div className='flexdot7 flex row'>
          {
            Object.keys(menuOptions).map((optKey, opti) => {
              const { title, icon, ref } = menuOptions[optKey];
              return <MenuOption title={title} icon={icon} _ref={ref} key={`menu_option_${opti}`} />
            })
          }
        </div>
      </div>  
      <div className='app-view flex xxlarge bold' style={{ paddingTop: scrolled ? headerHeight : 0 }}>
          <div className='allspace'><Parallax
              strength={400}
              className='app-view flex white xxlarge bold text-shadow'
          >
              <Background className='allwidth'>
                  <img src={parallaxBkg} alt="darduin-carrelage" style={{width: '100vw', height: '100vh', backgroundSize: "cover", backgroundRepeat: 'no-repeat'}}/>
              </Background>
              <div className='flexy exo text-shadow' style={{height: '80vh'}}>
                  <h1 className={isMobile ? 'xlarge' : ''}>Votre artisan local à {geoData?.ville || "votre service"} depuis 2020</h1>
                  
                  <div className='flexy'>
                    <div className={`flexy ${isMobile ? "col" : "row"} allwidth`} style={{whiteSpace: "nowrap", flexShrink: 0}}>
                      <p className={`flex flexdot4 ${isMobile ? '' : 'xxxlarge'} alignend`} style={{marginBottom: isMobile ? '0px' : '20px'}}>Je réalise vos</p>
                      {isMobile ? null : <span>&nbsp;</span>}
                      <h1 className={`flex flexdot6 justifystart alignstart ${isMobile ? 'nomargin' : ''}`}><ChangingTopic isMobile={isMobile}/></h1>
                    </div>
                  </div>
                      
                  <div className='flexy flexdot4'>
                    <button className={`app-button ${isMobile ? 'large' : 'xlarge'} margedt1`} onClick={() => smoothScroll(menuOptions.projets.ref)}>Voir mes réalisations</button>
                  </div>
              </div>
          </Parallax></div>
      </div>

      {/* SECTION 2*/}
      <div className={`screensize flex ${isMobile ? 'col padded-t' : 'row'} xlarge bold marble-bkg`}  ref={menuOptions.apropos.ref}>
          <div className='flexdot4'>
              <Slide triggerOnce>
                  <img src={logo} alt="logo" style={{width: isMobile ? '40vw' : '25vw'}} className='img-shadow' />  
                  <Zoom duration={250} delay={500}>
                      <img src={decennal} alt="decennal" style={{width: '10vw', position: 'absolute', top: '-28vw', right: '2vw'}} className='img-shadow' />  
                  </Zoom>
              </Slide>
          </div>

          <div className={`flexdot6 justified padded5 ${isMobile ? 'large' : 'xlarge'}`}>
              Depuis {(new Date()).getFullYear() - 2020} ans, je mets mon savoir-faire au service de vos projets de rénovation et d’aménagement intérieur et extérieur. Spécialisé dans la pose de carrelage et de revêtements de sol, j’accompagne particuliers et professionnels avec un travail soigné, durable et adapté à chaque besoin.
              <br /><br />
              J’interviens sur différents types de réalisations : pose de carrelage, faïence et crédence, création de douche à l’italienne, carrelage sur chape traditionnelle ou dalles sur plots, ainsi que la pose de parquet (massif, flottant, collé ou clipsé).
              <br /><br />
              Je réalise également des aménagements extérieurs comme les terrasses, les marches extérieures et la pose de pierre de parement, pour valoriser et embellir vos espaces.
              <br /><br />
              Chaque chantier est réalisé avec rigueur, précision et souci du détail, afin de garantir un résultat esthétique et durable. Mon objectif est simple : vous apporter un travail de qualité et un accompagnement fiable tout au long de votre projet.
              
              <div className='flex'>
                  <img alt="signature" src={signature} className={isMobile ? 'signature-mobile' : 'signature'}/*style={{position:'absolute', right: '5vw', width: '13vw', marginTop: '13vh'}}*/ />
              </div>
          </div>
      </div>

      {/* SECTION 3: Carousel*/}
      <div className='xlarge bold tertiarybkg white' ref={menuOptions.projets.ref}>
        <Gallery isMobile={isMobile} />
      </div>

      {/* SECTION 4*/}
      <div className='screensize flex xlarge bold primary tiles-bkg' ref={contactRef}>
          <ContactForm isMobile={isMobile} />
      </div>

      {/* GEO */}
      <div style={{ background: '#252525', paddingTop: '.1rem', paddingBottom: '2rem',  textAlign: 'center' }}>
        <p className="bold" style={{ marginBottom: '1rem', color: "white" }}>Recherches Associées</p>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem', justifyContent: 'center' }}>
          {geoPages.map(p => (
            <Link
              key={p.slug}
              to={`/${p.slug}`}
              style={{
                padding: '0.4rem 1rem',
                background: p.slug === slug ? '#333' : '#fff',
                color: p.slug === slug ? '#fff' : '#333',
                borderRadius: '999px',
                textDecoration: 'none',
                fontSize: '0.9rem',
                border: '1px solid #ccc',
              }}
            >
              Carreleur {p.ville}
            </Link>
          ))}
        </div>
      </div>

      {/* FOOTER */}
      <div className='flex app-footer'>
          <Footer 
            gotoSection={sectionName => smoothScroll(menuOptions[sectionName].ref)} 
            handleOpenFb={handleOpenFb} 
            isMobile={isMobile}
          />
      </div>

      
  </div>
}

export default MainPage;